<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <!--            <div class="ba_f mar_t20 mar_l20">-->
      <!--                <div class="pagetitle mar_b20">资产总览</div>-->
      <!--            </div>-->
      <div class="outmain pad_20 ba_f">
        <div class="pagetitle mar_b20">{{ $t('finance.overview.title') }}</div>
        <div class="flex-bet">
          <div class="bflex-5 outmain">
            <div class="flex-bet mar_t10">
              <div>
                <p class="color_6 fon_12">{{ $t('finance.overview.todayIncome') }}</p>
                <p class="fon_24 title35 mar_t5">{{info.todayIncome}}</p>
              </div>
              <div>
                <p class="color_6 fon_12">{{ $t('finance.overview.yesterdayIncome') }}</p>
                <p class="fon_24 title35 mar_t5">{{info.yesterdayIncome}}</p>
              </div>
            </div>
            <div>
              <div id="mainEch3" style="height: 260px"></div>
            </div>
          </div>
          <div class="bflex-5">
            <div class="flex-bet mar_t10">
              <div
                class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20"
              >
                <div>
                  <p class="title6 fon_14">{{ $t('finance.overview.platformIncome') }}</p>
                  <p class="fon_30 title35 lh16 pad_tb_20">{{info.todayRiderIncome}}</p>
                  <div class="flex">
                    <p class="fon_12 title6 lh25">{{ $t('finance.overview.yesterdayFullDay') }} {{info.yesterdayRiderIncome}}</p>
                  </div>
                </div>
                <div class="toolTip">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">
                      {{ $t('finance.overview.platformIncomeTip') }}
                    </div>
                    <button
                      type="button"
                      class="el-button question-button-tooltip el-tooltip el-button--text fon_12"
                    >
                      <span><i class="el-icon-question"></i></span>
                    </button>
                  </el-tooltip>
                </div>
              </div>
              <div
                class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20"
              >
                <div>
                  <p class="title6 fon_14">{{ $t('finance.overview.riderIncome') }}</p>
                  <p class="fon_30 title35 lh16 pad_tb_20">{{info.todayRiderIncome}}</p>
                  <div class="flex">
                    <p class="fon_12 title6 lh25">{{ $t('finance.overview.yesterdayFullDay') }} {{info.yesterdayRiderIncome}}</p>
                  </div>
                </div>
                <div class="toolTip">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">
                      {{ $t('finance.overview.riderIncomeTip') }}
                    </div>
                    <button
                      type="button"
                      class="el-button question-button-tooltip el-tooltip el-button--text fon_12"
                    >
                      <span><i class="el-icon-question"></i></span>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="flex-bet mar_t20">
              <div
                class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20"
              >
                <div>
                  <p class="title6 fon_14">{{ $t('finance.overview.shopRechargeAmount') }}</p>
                  <p class="fon_30 title35 lh16 pad_tb_20">{{info.todayStoreValue}}</p>
                  <div class="flex">
                    <p class="fon_12 title6 lh25">{{ $t('finance.overview.yesterdayFullDay') }} {{info.yesterdayStoreValue}}</p>
                  </div>
                </div>
                <div class="toolTip">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">
                      {{ $t('finance.overview.shopRechargeTip') }}
                    </div>
                    <button
                      type="button"
                      class="el-button question-button-tooltip el-tooltip el-button--text fon_12"
                    >
                      <span><i class="el-icon-question"></i></span>
                    </button>
                  </el-tooltip>
                </div>
              </div>
              <div
                class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20"
              >
                <div>
                  <p class="title6 fon_14">{{ $t('finance.overview.rewardAmount') }}</p>
                  <p class="fon_30 title35 lh16 pad_tb_20">{{info.todaySanction}}</p>
                  <div class="flex">
                    <p class="fon_12 title6 lh25">{{ $t('finance.overview.yesterdayFullDay') }}{{info.yesterdaySanction}}</p>
                  </div>
                </div>
                <div class="toolTip">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">
                      {{ $t('finance.overview.rewardTip') }}
                    </div>
                    <button
                      type="button"
                      class="el-button question-button-tooltip el-tooltip el-button--text fon_12"
                    >
                      <span><i class="el-icon-question"></i></span>
                    </button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mar_t20 ba_f outmain pad_20 ">
      <div class="pagetitle mar_b20">{{ $t('finance.overview.incomeBoard') }}</div>
      <div id="shujuEch" style="height: 360px;width: 100%"></div>
    </div>
    <div class="mar_t20 ba_f outmain pad_20 ">
      <div class="pagetitle mar_b20">{{ $t('finance.overview.dailyStats') }}</div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="zh" :label="$t('finance.overview.dateCol')"> </el-table-column>
        <el-table-column prop="zc" :label="$t('finance.overview.orderCountCol')"> </el-table-column>
        <el-table-column prop="zc" :label="$t('finance.overview.revenueCol')"> </el-table-column>
        <el-table-column prop="zc" :label="$t('finance.overview.platformIncomeCol')"> </el-table-column>
        <el-table-column prop="zc" :label="$t('finance.overview.riderCommissionCol')"> </el-table-column>
        <el-table-column prop="zc" :label="$t('finance.overview.otherCol')"> </el-table-column>
        <el-table-column :label="$t('common.operation')">
          <template slot-scope="scope">
            <div class="flex">
              <el-button type="text" @click="handleSeeEdit(scope.row)">{{ $t('common.view') }}</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.export') }}</el-button>
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import {platformAssets} from "@/api/finance"
export default {
  mounted() {
    
    this.getInfo();
  },
  data() {
    return {
      tableData: [],
      
      info:{},
      echarts1_option3: {
        color: ["#1890FF", "#2FC25B"],
        tooltip: {
          trigger: "axis",
          formatter: params => {
            var time =
              "时间：" +
              (Number(params[0].name) - 1) +
              ":00" +
              "~" +
              Number(params[0].name) +
              ":00";
            for (var i = 0; i < params.length; i++) {
              var numbers =
                "</br>" + params[i].seriesName + "：" + params[i].value;
              time += numbers;
            }
            return time;
          }
        },
        legend: {
          data: ["今日营业额", "昨日营业额"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          // 去除坐标轴上的刻度线
          axisTick: {
            show: false,
            lineStyle: {
              color: "#ccc",
              type: "dashed"
            }
          },
          // x轴的字体样式
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333",
              fontSize: "12"
            }
          },
          // x轴的颜色和宽度
          axisLine: {
            lineStyle: {
              color: "#4ECB73",
              width: 2 //这里是坐标轴的宽度,可以去掉
            }
          },
          data: []
        },
        yAxis: {
          type: "value",
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333",
              fontSize: "12"
            }
          },
          splitLine: {
            lineStyle: {
              type: "dotted",
              color: "#DDDDDD"
            },
            show: true
          }
        },
        series: [
          {
            name: "今日营业额",
            type: "line",
            stack: "总量",
            smooth: true,
            data: []
          },
          {
            name: "昨日营业额",
            type: "line",
            stack: "总量",
            smooth: true,
            data: []
          }
        ]
      },
      echarts1_option: {
        color: ["#4165D7", "#F1F1F9"],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["平台预计收入", "骑手预计收入"]
        },
        grid: {
          left: "3%",
          right: "5%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          // 去除坐标轴上的刻度线
          axisTick: {
            show: false,
            lineStyle: {
              color: "#ccc",
              type: "dashed"
            }
          },
          // x轴的字体样式
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333",
              fontSize: "12"
            }
          },
          // x轴的颜色和宽度
          axisLine: {
            lineStyle: {
              color: "#4ECB73",
              width: 2 //这里是坐标轴的宽度,可以去掉
            }
          },
          data: [
            "2020-8-17",
            "2020-8-16",
            "2020-8-15",
            "2020-8-14",
            "2020-8-13",
            "2020-8-12",
            "2020-8-11",
            "2020-8-11",
            "2020-8-11",
            "2020-8-11",
            "2020-8-10"
          ]
        },
        yAxis: {
          type: "value",
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333",
              fontSize: "12"
            }
          },
          splitLine: {
            lineStyle: {
              type: "dotted",
              color: "#DDDDDD"
            },
            show: true
          }
        },
        series: [
          {
            name: "平台预计收入",
            type: "bar",
            data: [10, 52, 75, 35, 40, 75, 30, 10, 52, 80, 25]
          },
          {
            name: "骑手预计收入",
            type: "bar",
            data: [10, 52, 20, 30, 25, 35, 80, 10, 52, 50, 60]
          }
        ]
        // series: [
        //     {type: 'bar'},
        //     {type: 'bar'},
        // ]
      }
    };
  },
  methods: {
    applyChartI18n() {
      const today = this.$t('finance.overview.todayIncome');
      const yesterday = this.$t('finance.overview.yesterdayIncome');
      const platform = this.$t('finance.overview.platformIncome');
      const rider = this.$t('finance.overview.riderIncome');
      const stack = this.$t('finance.overview.totalStack');
      const chartTime = this.$t('finance.overview.chartTime');
      this.echarts1_option3.legend.data = [today, yesterday];
      this.echarts1_option3.series[0].name = today;
      this.echarts1_option3.series[0].stack = stack;
      this.echarts1_option3.series[1].name = yesterday;
      this.echarts1_option3.series[1].stack = stack;
      this.echarts1_option3.tooltip.formatter = (params) => {
        let time =
          chartTime +
          (Number(params[0].name) - 1) +
          ":00" +
          "~" +
          Number(params[0].name) +
          ":00";
        for (let i = 0; i < params.length; i++) {
          time += "</br>" + params[i].seriesName + "：" + params[i].value;
        }
        return time;
      };
      this.echarts1_option.legend.data = [platform, rider];
      this.echarts1_option.series[0].name = platform;
      this.echarts1_option.series[1].name = rider;
    },
    jrgk() {
      let myChart = echarts.init(document.getElementById("mainEch3"));
      myChart.setOption(this.echarts1_option3, true);
    },
    llkb() {
      let myChart = echarts.init(document.getElementById("shujuEch"));
      myChart.setOption(this.echarts1_option, true);
    },
    async getInfo(){
      const {data}=await platformAssets();
      this.info=data;
      this.applyChartI18n();
      this.echarts1_option3.series[1].data=this.info.curveChart.map(item=>item.yesterdayMoney)
      this.echarts1_option3.series[0].data=this.info.curveChart.map(item=>item.money)
      this.echarts1_option3.xAxis.data=this.info.curveChart.map(item=>item.hours)
      this.echarts1_option.series[1].data=this.info.barChart.map(item=>item.riderMoney)
      this.echarts1_option.series[0].data=this.info.barChart.map(item=>item.money)
      this.echarts1_option.xAxis.data=this.info.barChart.map(item=>item.hours)
     
      this.jrgk();
    this.llkb();
      
    },
  }
};
</script>
<style lang="scss">
.el-form-item__content {
  text-align: left;
}

.tsinput .el-input {
  width: 300px !important;
}
</style>
